import { useRef, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import GoogleSignInButton from "../atoms/googleSignInButton";

export function Navigation() {
  const location = useLocation();

  return (
    <div>
      <h1>Navigation</h1>
      <GoogleSignInButton />
    </div>
  );
}
